import { Separator } from '#app/shared/ui/data-display/Separator.js'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'

type detailsObject = {
  name: string
  value: string
}

type Props = {
  imgPath: string
  detailName: string
  details: detailsObject[]
  isLast: boolean
}

export default function DetailsRowCard({
  imgPath,
  detailName,
  details,
  isLast,
}: Props) {
  return (
    <div>
      <Spacer size="32px" />
      <div
        className={`
          flex flex-col items-start justify-between gap-6

          md:flex-row
        `}
      >
        <div className="flex items-center gap-2">
          <img className="h-5 w-5" src={imgPath} alt="detail-icon-image" />
          <p className="text-h5-bold text-neutral-900">{detailName}</p>
        </div>
        <DetailsRight details={details} />
      </div>
      <Spacer
        className={`
          hidden

          md:block
        `}
        sizeMd="40px"
      />
      {!isLast && (
        <Separator
          className={`
            hidden bg-neutral-75

            md:inline-flex
          `}
        />
      )}
    </div>
  )
}

type detailsRightProps = {
  details: detailsObject[]
}

export function DetailsRight({ details }: detailsRightProps) {
  return (
    <div
      className={`
        flex w-full flex-col gap-5

        sm:w-[436px]
      `}
    >
      {details.map((detail) => (
        <div
          className={`
            flex h-6 w-full items-start gap-[41px] border-b border-neutral-75
          `}
          key={detail.name}
        >
          <p
            className={`
              h-full w-[346px] text-nowrap text-start text-subtitle1-bold
              text-neutral-900
            `}
          >
            {detail.name}
          </p>
          <p
            className={`
              h-full w-[146px] text-start text-subtitle1-medium text-neutral-900
            `}
          >
            {detail.value}
          </p>
        </div>
      ))}
    </div>
  )
}
